import type { ReportMoney } from '@didto/domain';
import { supabase } from './supabase';

/**
 * The owner's money reports (Phase 8A, ADR-043): one read, refused unless the caller is the signed-in owner holding
 * report.money at the location. The server computes every figure; the page only lays them out.
 */
export const reportKeys = {
  /** Today's report, read without dates: it tells the page the location's business date. */
  today: (locationId: string) => ['report-money', locationId, 'today'] as const,
  period: (locationId: string, from: string, to: string) =>
    ['report-money', locationId, from, to] as const,
  all: ['report-money'] as const,
};

export async function fetchReportMoney(
  locationId: string,
  from: string | null,
  to: string | null,
): Promise<ReportMoney> {
  const { data, error } = await supabase.rpc('report_money', {
    p_location_id: locationId,
    ...(from && to ? { p_from: from, p_to: to } : {}),
  });
  if (error) throw error;
  return data as unknown as ReportMoney;
}
